import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import 'swiper/css/zoom'

export default class extends Controller {
  static values = { 
    initialSlide: Number
  }

  connect() {
    //console.log('Swiper product controller connected')
    this.initializeSwiper()
  }

  disconnect() {
    if (this.mainContainer && this.handleMainImageClick) {
      this.mainContainer.removeEventListener('click', this.handleMainImageClick)
      this.mainContainer = null
      this.handleMainImageClick = null
    }

    if (this.mainSwiper) {
      this.mainSwiper.destroy()
      this.mainSwiper = null
    }
    if (this.thumbSwiper) {
      this.thumbSwiper.destroy()
      this.thumbSwiper = null
    }
  }

  initializeSwiper() {
    // Apply styles for smaller gray arrows
    //this.applyCustomStyles()
    
    // First initialize thumbnail swiper if it exists
    const thumbContainer = this.element.querySelector('.product-thumb-swiper') || 
                           this.element.querySelector('.swiper-container.product-thumb-swiper')
    if (thumbContainer) {
      this.thumbSwiper = new Swiper(thumbContainer, {
        modules: [Navigation, Thumbs],
        slidesPerView: 4,
        spaceBetween: 10,
        watchSlidesProgress: true,
        navigation: {
          nextEl: thumbContainer.querySelector('.thumb-button-next'),
          prevEl: thumbContainer.querySelector('.thumb-button-prev'),
        },
        breakpoints: {
          320: { slidesPerView: 3 },
          768: { slidesPerView: 4 }
        }
      })
    }

    // Then initialize main swiper
    const mainContainer = this.element.querySelector('.product-main-swiper') || 
                          this.element.querySelector('.swiper-container.product-main-swiper')
    if (mainContainer) {
      this.mainContainer = mainContainer

      this.mainSwiper = new Swiper(mainContainer, {
        modules: [Navigation, Pagination, Thumbs, Zoom],
        slidesPerView: 1,
        spaceBetween: 10,
        initialSlide: this.hasInitialSlideValue ? this.initialSlideValue : 0,
        navigation: {
          nextEl: mainContainer.querySelector('.swiper-button-next'),
          prevEl: mainContainer.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: mainContainer.querySelector('.swiper-pagination'),
          clickable: true,
        },
        thumbs: this.thumbSwiper ? { swiper: this.thumbSwiper } : undefined,
        zoom: {
          enabled: true,
          maxRatio: 2,
          minRatio: 1,
          toggle: false,
        },
        on: {
          slideChange: () => this.updateImageInfo()
        }
      })

      // Update info on initial load
      this.updateImageInfo()
      this.setupSingleClickZoom()
    }
  }

  setupSingleClickZoom() {
    if (!this.mainContainer || !this.mainSwiper) return

    this.handleMainImageClick = (event) => {
      if (!this.mainSwiper || !this.mainSwiper.allowClick) return
      if (event.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination')) return

      const zoomTarget = event.target.closest('.swiper-zoom-container, .swiper-zoom-container img')
      if (!zoomTarget) return

      const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex]
      if (!activeSlide) return

      if (activeSlide.classList.contains('swiper-slide-zoomed')) {
        this.mainSwiper.zoom.out()
      } else {
        this.mainSwiper.zoom.in()
      }
    }

    this.mainContainer.addEventListener('click', this.handleMainImageClick)
  }

  updateImageInfo() {
    if (!this.mainSwiper) return

    const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex]
    if (!activeSlide) return

    const activeImg = activeSlide.querySelector('img')
    if (!activeImg) return

    // Get data attributes from the active image
    // Try both format types (data-width and data-img-width)
    const width = activeImg.dataset.width || activeImg.dataset.img_width || ''
    const finish = activeImg.dataset.finish || activeImg.dataset.img_finish || ''
    const color = activeImg.dataset.color || activeImg.dataset.img_color || ''

    // Update the display elements
    const widthEl = document.getElementById('img-width')
    const finishEl = document.getElementById('img-finish')
    const colorEl = document.getElementById('img-color')

    if (widthEl && width) widthEl.textContent = width
    if (finishEl && finish) finishEl.textContent = finish
    if (colorEl && color) colorEl.textContent = color
  }

  applyCustomStyles() {
    const style = document.createElement('style')
    style.textContent = `
      .product-gallery .swiper-button-next,
      .product-gallery .swiper-button-prev,
      .product-gallery .thumb-button-next,
      .product-gallery .thumb-button-prev {
        color: #888;
        transform: scale(0.7);
      }
      
      .product-gallery .swiper-button-next:hover,
      .product-gallery .swiper-button-prev:hover,
      .product-gallery .thumb-button-next:hover,
      .product-gallery .thumb-button-prev:hover {
        color: #555;
      }
      
      .product-gallery .swiper-pagination {
        position: relative;
        margin-top: 10px;
      }
      
      .product-gallery .product-details {
        text-align: center;
        margin-top: 1rem;
      }
      
      .product-gallery .detail-item {
        display: flex;
        gap: 10px;
        justify-content: center;
      }
    `
    document.head.appendChild(style)
  }
}
